import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setQuery } from "../../store/slices/complaintsSlice.ts";
import { readBranches } from "../../services/branch.service.ts";
import { readPositions } from "../../services/position.service.ts";
import Branch from "../../models/Branch.ts";
import { Position } from "../../models/Position";
import { useNavigate } from "react-router-dom";

const FilterComplaints = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [branches, setBranches] = React.useState<Branch[]>([]);
  const [positions, setPositions] = React.useState<Position[]>([]);
  const [timer, setTimer] = React.useState<any>(null);
  const [showPills, setShowPills] = React.useState(false);

  const initialValues = {
    param: "",
    branchId: -1,
    positionId: -1,
  };

  const [filters, setFilters] = React.useState(initialValues);

  useEffect(() => {
    readBranches()
      .then((res) => setBranches(res || []))
      .catch(() => setBranches([]));
    readPositions()
      .then((res) => setPositions(res || []))
      .catch(() => setPositions([]));
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setFilters((prevFilters) => ({ ...prevFilters, param: newValue }));
    if (newValue === "") {
      setShowPills(false);
    } else {
      setShowPills(true);
    }
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(
      setTimeout(() => {
        const updatedFilters = { ...filters, param: newValue };
        const queryString = Object.keys(updatedFilters)
          .filter(
            (key) => updatedFilters[key] !== -1 && updatedFilters[key] !== ""
          )
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(
                updatedFilters[key]
              )}`
          )
          .join("&");
        dispatch(setQuery(queryString));
        setTimer(null);
      }, 500)
    );
  };

  const updateFilters = (params?: {}) => {
    const filtros = { ...filters, ...params };
    const queryString = Object.keys(filtros)
      .filter((key) => filtros[key] !== -1 && filtros[key] !== "")
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(filtros[key])}`
      )
      .join("&");
    dispatch(setQuery(queryString));
  };

  const selectedFilters = (filters: any) => {
    let selected: any = [];
    for (const key in filters) {
      if (filters[key] !== -1 && filters[key] !== "") {
        let value = filters[key];
        let valueName = "";
        let keyName = "";
        switch (key) {
          case "param":
            keyName = "Búsqueda";
            valueName = value;
            break;
          case "branchId":
            keyName = "Sucursal";
            valueName = branches.find((item) => item.id === value)?.name || "";
            break;
          case "positionId":
            keyName = "Puesto";
            valueName = positions.find((item) => item.id === value)?.name || "";
            break;
          default:
            keyName = key;
            valueName = value;
            break;
        }
        selected.push({ key, value, valueName, keyName });
      }
    }

    if (selected.length === 0) setShowPills(false);
    return selected;
  };

  const removeFilter = (key: string) => {
    setFilters({ ...filters, [key]: initialValues[key] });

    const updatedFilters = { ...filters, [key]: initialValues[key] };
    const queryString = Object.keys(updatedFilters)
      .filter((key) => updatedFilters[key] !== -1 && updatedFilters[key] !== "")
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            updatedFilters[key]
          )}`
      )
      .join("&");
    dispatch(setQuery(queryString));
  };

  return (
    <div className="w-100">
      <div className="input-group mb-2 w-100">
        <button
          className="btn btn-white dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
          style={{ borderRadius: "999px 0 0 999px" }}

        >
          <span className="d-none d-md-inline">Filtrar</span>
          <span className="d-inline d-md-none">
            <i className="fa fa-filter"></i>
          </span>
          <b className="caret"></b>
        </button>
        <div className="dropdown-menu p-4" onClick={(e) => e.stopPropagation()}>
          <label className="mt-2">Sucursal:</label>
          <select
            className="form-select mt-1"
            id="branchId"
            name="branchId"
            onChange={(e) =>
              setFilters({ ...filters, branchId: Number(e.target.value) })
            }
            value={filters.branchId}
          >
            <option value={-1} disabled>
              Todas
            </option>
            {branches.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>

          <label className="mt-2">Puesto:</label>
          <select
            className="form-select mt-1"
            id="positionId"
            name="positionId"
            onChange={(e) =>
              setFilters({ ...filters, positionId: Number(e.target.value) })
            }
            value={filters.positionId}
          >
            <option value={-1} disabled>
              Todos
            </option>
            {positions.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              );
            })}
          </select>

          <div className="row mt-3">
            <div className="col">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setFilters({
                    param: "",
                    branchId: -1,
                    positionId: -1,
                  });
                  updateFilters({
                    param: "",
                    branchId: -1,
                    positionId: -1,
                  });
                  setShowPills(false);
                }}
                className="btn btn-amarillo d-block w-100 btn-lg fs-14px"
                type="button"
              >
                Limpiar
              </button>
            </div>
            <div className="col">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  updateFilters();
                  setShowPills(true);
                }}
                className="btn btn-azul d-block w-100 btn-lg fs-14px"
              >
                Aplicar
              </button>
            </div>
          </div>
        </div>

        <div className="flex-fill position-relative">
          <div className="input-group">
            <div
              className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0"
              style={{ zIndex: 10 }}
            >
              {timer ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <i className="fa fa-search opacity-5"></i>
              )}
            </div>
            <input
              type="text"
              className="form-control px-35px bg-light"
              placeholder="Buscar por nombre o comentarios..."
              id="param"
              name="param"
              onChange={(e) => handleSearchChange(e)}
              value={filters.param}
            />
          </div>
        </div>
        {/* <button
          className="btn btn-azul"
          style={{ marginLeft: 10 }}
          onClick={() => navigate("/quejas/nuevo")}
        >
          Agregar
        </button> */}
      </div>
      <div className="mb-3">
        {showPills &&
          selectedFilters(filters).map((filter: any) => (
            <div
              key={filter.key}
              className="badge bg-primary text-white fs-6 me-2 position-relative pe-4"
            >
              {filter.keyName}: {filter.valueName}
              <button
                type="button"
                className="btn-close btn-close-white position-absolute top-0 end-0 mt-1 me-1 ps-1"
                aria-label="Close"
                onClick={() => removeFilter(filter.key)}
              ></button>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FilterComplaints;
